module.exports = __webpack_public_path__ + "img/new-object-search.ef0037dc.png";